<script lang="ts">
  import Block from "./Block.astro";

  interface SetProps {
    type: string;
    attrs: any;
  }

  export let attrs: any;
</script>

<Block block={attrs.values} />
